const omit = (obj, keys) => {
  return Object.entries(obj)
    .filter(([key]) => !keys.includes(key))
    .reduce((acc, [key, val]) => Object.assign(acc, {[key]: val}), {})
}

export default omit
